import { useContext } from 'react';
import { IconPlus, IconFolderPlus } from '@tabler/icons-react';
import { LangContext } from '@/context/LangProvider';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface EmptyGroupStateProps {
  onAddQuestions: () => void;
  onCreateSubgroup: () => void;
  isDisabled?: boolean;
  isAddingQuestionsDisabled?: boolean;
  isSubgroup?: boolean;
  isCreatingSubgroupDisabled?: boolean;
}

function EmptyGroupState({
  onAddQuestions,
  onCreateSubgroup,
  isDisabled = false,
  isAddingQuestionsDisabled = false,
  isSubgroup = false,
  isCreatingSubgroupDisabled = false,
}: EmptyGroupStateProps) {
  const { lang } = useContext(LangContext);

  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center">
      <p className="text-gray-600 mb-6 text-sm">
        {isSubgroup
          ? lang.get('msg.dragQuestionsHereFromOtherSections')
          : lang.get('msg.chooseHowToOrganiseThisGroup')}
      </p>
      {!isSubgroup && <p className="text-gray-500 mb-4 text-xs">{lang.get('msg.or')}</p>}
      <div className="flex gap-3">
        <Button
          type="button"
          variant="outline"
          onClick={onAddQuestions}
          disabled={isDisabled || isAddingQuestionsDisabled}
          className={cn(
            'flex items-center gap-2',
            'border-green-600 text-green-700 hover:bg-green-50 hover:text-green-700',
          )}
        >
          <IconPlus size={18} />
          {lang.get('msg.addQuestions')}
        </Button>
        {!isSubgroup && (
          <Button
            type="button"
            variant="outline"
            onClick={onCreateSubgroup}
            disabled={isCreatingSubgroupDisabled}
            className={cn(
              'flex items-center gap-2',
              'border-pink-600 text-pink-700 hover:bg-pink-50 hover:text-pink-700',
            )}
          >
            <IconFolderPlus size={18} />
            {lang.get('msg.createSubgroup')}
          </Button>
        )}
      </div>
    </div>
  );
}

export default EmptyGroupState;
